<template>
<Dialog header="Denetleme Dosyaları" v-model:visible="show" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '90vw'}" :maximizable="true" :modal="true">
    

<FileUpload   accept=".xlsx, .xls, .csv" @select="onFilesAdded"  @remove="onFilesRemove"   v-model="files" :multiple="true" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin" :fileLimit="10"   :maxFileSize="1000000" class="">
  <template #empty>
      <p>Dosyayı sürükleyip bırakın</p>
  </template>
</FileUpload>
<div class="flex align-items-center justify-content-center mt-3 mb-3 flex-column" v-if="ready_to_upload">
<h4 class="text-primary mt-1 mb-1 p-link" @click="showReadyToUploadList">{{businesses_to_upload.length}} adet tedarikçi yüklenmeye hazır</h4>
<h4 class="text-red-500 mt-1 mb-1 p-link" @click="showErrorList">{{businesses_with_error.length}} adet tedarikçi verisinde hata bulundu</h4>
</div>
<!-- businesses to upload view-->
<template v-if="show_business_list">
	<ScrollPanel style="width: 100%; height: 300px">
	<DataTable :value="businesses_to_upload" responsiveLayout="scroll">
      <Column field="business_name" header="İsim"></Column>
      <Column field="business_address" header="Adres"></Column>
      <Column field="business_contact" header="Yetkili İsim"></Column>
      <Column field="business_role" header="Yetkili Görevi"></Column>
      <Column field="business_email" header="Yetkili Email"></Column>
      <Column field="business_phone" header="Yetkili Telefon"></Column>
      <Column field="business_personel_count" header="Toplam Çalışan Sayısı"></Column>
      <Column field="business_shifts" header="Çalışma Saatleri/Vardiya Bilgileri (molalar ile)"></Column>
      <Column field="business_area" header="Tesis Alanı (m2)"></Column>
      <Column field="business_supplies" header="Arçelik İçin Tedarik Edilen Ürünler"></Column>
      <Column field="audit_date" header="Denetim Tarihi"></Column>
      <Column field="auditor" header="Denetçinin Adı-Soyadı"></Column>
      <Column field="audit_points" header="Denetim Puanı"></Column>
      <Column field="audit_result" header="Denetim Sonucu"></Column>
      <Column header="">
          <template #body="slotProps">
              <Button  icon="pi pi-trash" @click="removeBusinessFromList(slotProps.data.id)" class="p-button-danger p-button-outlined p-button-sm"/>
          </template>
      </Column>
  </DataTable>
</ScrollPanel>
</template>
<!-- businesses to upload view-->

<!-- businesses with error view-->
<template v-if="show_error_business_list">
	<ScrollPanel style="width: 100%; height: 300px">
	<DataTable :value="businesses_with_error" responsiveLayout="scroll">
      <Column header="İsim">
          <template #body="slotProps">
              <template v-if="slotProps.data.name">
              	<p>{{slotProps.data.name}}</p>
              </template>
              <template v-else>
              	<p class="text-red-500">İsim Eksik</p>
              </template>
          </template>
      </Column>
      <Column header="Tedarikçi Kodu">
          <template #body="slotProps">
              <template v-if="slotProps.data.suppliercode">
              	<p>{{slotProps.data.suppliercode}}</p>
              </template>
              <template v-else>
              	<p class="text-red-500">Tedarikçi Kodu Eksik</p>
              </template>
          </template>
      </Column>
      <Column header="Yetkili İsim">
          <template #body="slotProps">
              <template v-if="slotProps.data.user_name">
              	<p>{{slotProps.data.user_name}}</p>
              </template>
              <template v-else>
              	<p class="text-red-500">Yetkili İsim Eksik</p>
              </template>
          </template>
      </Column>
      <Column header="Yetkili Email">
          <template #body="slotProps">
              <template v-if="slotProps.data.user_email">
              	<p>{{slotProps.data.user_email}}</p>
              </template>
              <template v-else>
              	<p class="text-red-500">Yetkili Email Eksik</p>
              </template>
          </template>
      </Column>
      <Column header="Yetkili Telefon">
          <template #body="slotProps">
              <template v-if="slotProps.data.user_phone">
              	<p>{{slotProps.data.user_phone}}</p>
              </template>
              <template v-else>
              	<p class="text-green-500">Yetkili Telefon Eksik</p>
              </template>
          </template>
      </Column>
      <Column header="Yetkili Görevi">
          <template #body="slotProps">
              <template v-if="slotProps.data.user_position">
              	<p>{{slotProps.data.user_position}}</p>
              </template>
              <template v-else>
              	<p class="text-green-500">Yetkili Görevi Eksik</p>
              </template>
          </template>
      </Column>
      
      
  </DataTable>
</ScrollPanel>
</template>
<!-- businesses with error view-->


    <template #footer>
        <Button label="İptal" icon="pi pi-times" @click="close" class="p-button-danger p-button-outlined p-button-sm mt-4"/>
        <Button v-if="ready_to_upload" label="Yükle" icon="pi pi-check" @click="uploadSuppliers" autofocus  class="p-button-primary p-button-outlined p-button-sm mt-4"  :loading="$store.state.ui.submitting"/>
    </template>
</Dialog>
</template>

<script>
const columns_arr = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","AA","AB","AC","AD","AE","AF","AG","AH","AI"];
import * as XLSX from 'xlsx'
import moment from "moment"
export default {

  name: 'AuditUploadDialog',

  data () {
    return {
    	 files:[],
    	 show:false,
    	 ready_to_upload:false,
    	 current_row:2,
    	 current_column:0,
    	 worksheet:null,
    	 businesses_to_upload:[],
    	 businesses_with_error:[],
    	 show_business_list:false,
    	 show_error_business_list:false,
    }
  },
  methods:{
  	showReadyToUploadList()
  	{
  		this.show_error_business_list = false
  		console.log(this.businesses_to_upload)
  		if(this.show_business_list)
  		{
  			this.show_business_list = false
  			return false
  		}
  		this.show_business_list = true
  		
  	},
  	showErrorList()
  	{
  		this.show_business_list = false
  		console.log(this.businesses_with_error)
  		if(this.show_error_business_list)
  		{
  			this.show_error_business_list = false
  			return false
  		}
  		this.show_error_business_list = true
  		
  	},
  	removeBusinessFromList(id)
  	{
  		this.businesses_to_upload = this.businesses_to_upload.filter((item)=>{return item.id !== id})
  	},
  	onFilesAdded(event)
    {
     console.log("onFilesRemove");
     this.onFilesRemove()
     setTimeout(()=>{
     	for (let i = 0; i < event.files.length; i++)
     	{
     		this.handleXml(event.files[i],i) 
     	}
     	this.ready_to_upload = true

     	 
     })
         
    },
    onFilesRemove(event)
    {
    this.ready_to_upload = false
		this.current_column = 0
		this.current_row=2
		this.worksheet = null
		this.businesses_to_upload = []
  	this.businesses_with_error= []
  	this.show_business_list = false
    this.show_error_business_list = false

    },
    handleXml(f,index)
    {    	
    	let reader = new FileReader()
    	console.log("handleXml");
    	reader.onload = (e)=>{
    		let data = new Uint8Array(e.target.result)
    		let workbook = XLSX.read(data, {type: 'array'});
    		console.log("workbook")
    		console.log(workbook)
    		let current_sheet = workbook.SheetNames[0]; 
    		this.worksheet = workbook.Sheets[current_sheet]; 		
			//let current_cell_value =this.getCurrentCellValue()
			let business = this.workFirstSheet()
			console.log("workFirstSheet")
			console.log(business)
			current_sheet = workbook.SheetNames[1];
			this.worksheet = workbook.Sheets[current_sheet];
			business = this.workSecondSheet(business)
			console.log("workSecondSheet")
			console.log(this.businesses_to_upload[index])
			
			
    	}
    	reader.readAsArrayBuffer(f);
    },
    workFirstSheet()
    {
    	let obj = {
    		 id:this.generateId(),
    		 business_name:this.getCorrdinatedCellValue(2,"B"),
	    	 business_address:this.getCorrdinatedCellValue(3,"B"),
	    	 business_contact:this.getCorrdinatedCellValue(4,"B"),
	    	 business_role:this.getCorrdinatedCellValue(5,"B"),
	    	 business_phone:this.getCorrdinatedCellValue(6,"B"),
	    	 business_email:this.getCorrdinatedCellValue(7,"B"),
	    	 business_personel_count:this.getCorrdinatedCellValue(8,"B"),
	    	 business_shifts:this.getCorrdinatedCellValue(9,"B"),
	    	 business_area:this.getCorrdinatedCellValue(10,"B"),
	    	 business_supplies:this.getCorrdinatedCellValue(11,"B"),
	    	 audit_date:moment(this.getCorrdinatedCellValue(13,"B")),
	    	 auditor:this.getCorrdinatedCellValue(14,"B"),
	    	 audit_points:this.getCorrdinatedCellValue(17,"B"),
	    	 audit_result:this.getCorrdinatedCellValue(18,"B"),
	    	 submissions:[],
	    	 nonconformities:[],

    	}
    	this.businesses_to_upload.push(obj)
    	return obj
    },
    workSecondSheet(business)
    {
    	let row_ind = 2
    	let buss_result = this.getQuestionData(row_ind,business.id)
    	console.log("buss_result")
    	console.log(buss_result)
    	return buss_result
    },
    getQuestionData(row_ind,business_id)
    {
    	let question = this.getCorrdinatedCellValue(row_ind,"D")
    	if(question)
    	{
    		console.log("getQuestionData")
    		let obj = {
    			question:question,
    			submission:this.getCorrdinatedCellValue(row_ind,"E"),
    			discovery:this.getCorrdinatedCellValue(row_ind,"F")
    		}
    		let the_ind = this.businesses_to_upload.findIndex((item)=>{return item.id == business_id})
    		this.businesses_to_upload[the_ind].submissions.push(obj)
    		this.getQuestionData(row_ind+1,business_id)
    	}
    	else
    	{
    		let the_ind = this.businesses_to_upload.findIndex((item)=>{return item.id == business_id})
    		console.log(the_ind)
    		return the_ind   		
    	}

    },
    getCurrentCellValue()
		{
			let current_cell_address = columns_arr[this.current_column]+this.current_row;				
			let current_cell = this.worksheet[current_cell_address];
			let current_cell_value = (current_cell ? current_cell.v : undefined);
			if(current_cell_value==undefined)
			{
				current_cell_value = ""
			}
			return current_cell_value;
		},

		getCorrdinatedCellValue(row,column)
		{
			let current_cell_address = column+row;				
			let current_cell = this.worksheet[current_cell_address];
			let current_cell_value = (current_cell ? current_cell.v : undefined);
			if(current_cell_value==undefined)
			{
				current_cell_value = ""
			}
			return current_cell_value;
		},

	checkEmailSyntax(email)
	{
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
	  {
	    return true
	  }	   
	  return false
	},
    async readBusinessLine()
  	{
		this.current_row += await 1;
		this.current_column = await 0
		let bus_obj =  await {};
		let is_error = false
		let the_name =  await this.getCurrentCellValue()
		if(the_name)
		{
			if(the_name=="")
			{
				is_error = true
			}
			bus_obj.name =  await the_name.replaceAll('\"', '')

			this.current_column +=  await 1
			let the_data =  await this.getCurrentCellValue()
			if(!the_data)
			{
				is_error = true
			}
			bus_obj.suppliercode =  await the_data
			

			this.current_column +=  await 1
			the_data =  await this.getCurrentCellValue()
			if(!the_data)
			{
				//is_error = true
			}
			bus_obj.user_name =  await the_data

			this.current_column +=  await 1
			the_data =  await this.getCurrentCellValue()
			if(!the_data)
			{
				//is_error = true
			}
			else
			{
				if(!this.checkEmailSyntax(the_data))
				{
					is_error = true
				}
				else
				{
					bus_obj.user_email =  await the_data
				}
			}
			//
			

			this.current_column +=  await 1
			the_data =  await this.getCurrentCellValue()
			bus_obj.user_phone =  await the_data

			this.current_column +=  await 1
			the_data =  await this.getCurrentCellValue()
			bus_obj.user_position =  await the_data

			for(let item of this.$store.state.suppliers.attibutes)
			{
				this.current_column +=  await 1
				the_data =  await this.getCurrentCellValue()
				bus_obj[item.id] =  await the_data

			}

			if(is_error)
			{
				this.businesses_with_error.push(bus_obj)
			}
			else
			{
				this.businesses_to_upload.push(bus_obj)
			}
			
			await this.readBusinessLine()
			
		}
		else
		{

			await console.log(this.businesses_to_upload)
			this.ready_to_upload = true
				
			//await this.submitAllSuppliers()
			//this.uploadProcess = await "done"
			//this.current_column = await 0
			//this.current_row = await 1
			return  await false
		}
	},
	uploadSuppliers()
	{

		let formdata = new FormData()
		console.log(this.businesses_to_upload)
		return false
		formdata.append("suppliers",JSON.stringify(this.businesses_to_upload))
		console.log(uploadpage);
		//return false
		this.generalSubmission(formdata,uploadpage+"/submit_audits/"+this.$route.params.id,this.afteruploadSuppliers)

	},
	afteruploadSuppliers(response)
	{
		console.log(response.data);
		this.$store.dispatch('suppliers/setSuppliersRenewed',true) 
		this.close()
	},
  	close()
  	{
  		this.show = false 
  	},
  	open()
  	{
  		this.show = true 
  	},
  },
};
</script>

<style lang="css" scoped>
</style>